import * as ko from "knockout";
import {IResponse, IRuleset, TRouteId} from "../../index";
import {IVariableParams, VariableAbstract} from "./VariableAbstract";
import {TServiceName} from "../../constants/ApiServices";
import pubsub from "../../pubsub";
import {IUpdateRulesetEventParams} from "../ruleset/index";
import {nsTooltip} from "../../util/nsTooltip";
import {REQUEST_MESSAGE} from "../../constants/Language";
import {nsFa} from "../fa/fn";
import {getHash} from "../../constants/RouteDefinitions";
import i = nsFa.i;

export {template} from "./VariableAbstract";

export class viewModel extends VariableAbstract<IRuleset> {
    protected routeId: TRouteId = 'rulesetdetails'
    protected serviceName: TServiceName = 'getruleset'

    constructor(protected override params: IVariableParams<IRuleset>) {
        super(params);
        pubsub.on(this, 'ruleset.updated', (e: JQuery.Event, updateEventParams: IUpdateRulesetEventParams) => {
            if (updateEventParams.oldRuleset.id == this.id) {
                this.request()
            }
        })

    }

    protected override getRequest(): Promise<any> {
        return this.req
            .request(this.getParams(), true)
            .then((resp: IResponse<IRuleset[]>) => {
                return resp.data
            })
            .catch((resp: IResponse) => {
                const type = resp.returncode == '22' ? 'info' : 'danger';
                this.messageData({message: resp.lasterror, type: type});
            });
    }

    protected override initRequestMessage() {
        if (this.params.spinnerOnly) {
            let html: string = i('fa-spin fa-spinner fa-rw')
            if (this.params.id) {
                html += ` <a href="${getHash('rulesetdetails', {id: this.params.id})}">${this.params.id}</a>`
            }
            this.html(html)
        } else {
            this.messageData(this.params.requestMessage ?? {message: REQUEST_MESSAGE});
        }
    }

    protected override getTitle(): string {
        const item = ko.unwrap(this.item);
        return item ? (nsTooltip.getTitle_ruleset(item) ?? '') : '';
    }

    override dispose() {
        super.dispose();
        pubsub.off(this)
    }
}
